module.exports = __webpack_public_path__ + "img/garnelenbowloben.866b14dd.png";